<rx-banner
	class="rx-intuitive-for-doctor__read-only-banner"
	*ngIf="isReadOnlyBannerVisible$ | async"
	[type]="'info'"
	appearance="intuitive"
	[message]="'ReadOnlyMode.ReadOnlyMessage' | translate"
></rx-banner>

<rx-intuitive-patient-header *ngIf="step$ | async | mapper: shouldShowPatientHeader"></rx-intuitive-patient-header>

<ng-container [ngSwitch]="step$ | async">
	<div *ngSwitchCase="flowRxSteps.PatientDetails" [attr.data-bi-attr-flow-rx-step]="flowRxSteps.PatientDetails">
		<rx-intuitive-patient-details (patientCreated)="goToStep(flowRxSteps.ProcedureSelection)" />
	</div>

	<div
		*ngSwitchCase="flowRxSteps.ProcedureSelection"
		class="rx-procedure-tiles-container"
		[attr.data-bi-attr-flow-rx-step]="flowRxSteps.ProcedureSelection"
	>
		<rx-select-procedure (procedureSelected)="goToStep(flowRxSteps.RxForm)"></rx-select-procedure>
	</div>

	<div *ngSwitchCase="flowRxSteps.RxForm" [attr.data-bi-attr-flow-rx-step]="flowRxSteps.RxForm">
		<rx-procedure-selected-page></rx-procedure-selected-page>
	</div>

	<rx-intuitive-summary-footer *ngIf="isSummaryMode$ | async" (sendClicked)="sendClicked.emit()" />
</ng-container>
